/**
 * Parse a server datetime to epoch ms, treating a timezone-less string as UTC
 * (the backend returns naive UTC datetimes from Mongo; `new Date(str)` would
 * read them as LOCAL time).
 */
export function parseServerMs(ts: string | null | undefined): number {
  if (!ts) return NaN;
  const hasTz = /([zZ])$|[+-]\d{2}:?\d{2}$/.test(ts);
  return new Date(hasTz ? ts : `${ts}Z`).getTime();
}
